import { CurrencyPipe, NgClass, NgStyle } from '@angular/common';
import { Component, effect, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { AccountStore, UserStore } from '@bn/auth/stores';

@Component({
  selector: 'bn-dashboard-billing-overview',
  templateUrl: './billing-overview.component.html',
  styleUrls: ['./billing-overview.component.scss'],
  imports: [RouterLink, RouterLinkActive, FaIconComponent, NgClass, NgStyle, CurrencyPipe, NgxSkeletonLoaderModule, TooltipModule],
})
export class BillingOverviewComponent {
  #accountStore = inject(AccountStore);
  userStore = inject(UserStore);
  billingOverview = this.#accountStore.billingOverview;
  endsInText = '';
  percentage = 0;
  userTrial = this.userStore.userTrial();

  constructor() {
    // Call billing at first open
    this.#accountStore.getBilling({ isBillableUser: true });

    effect(() => {
      const billingOverview = this.billingOverview();

      if (!billingOverview) return;

      this.percentage = billingOverview.LastRechargeBalance > 0 ? (billingOverview.Balance / billingOverview.LastRechargeBalance) * 100 : 0;

      const daysText = this.userTrial().ends.days > 1 ? `in ${this.userTrial().ends.days + 1} days` : 'today';
      this.endsInText = !this.userTrial().ends.isExpired ? `Trial ends ${daysText}` : 'Your trial period has ended';
    });
  }
}
